export const adminAccessCodesQueryKeys = {
  all: ['admin-access-codes'],
  codes: () => [...adminAccessCodesQueryKeys.all, 'codes'],
  resellers: () => [...adminAccessCodesQueryKeys.all, 'resellers'],
};
